import { HoldersResponseData } from "@/pages/api/holders";
import z from "zod";

export const GetTokenHoldersResponseSchemaV1 = z.object({
  users: z.array(
    z.object({
      id: z.number(),
      address: z.string(),
      twitterUsername: z.string(),
      twitterName: z.string(),
      twitterPfpUrl: z.string(),
      twitterUserId: z.string() /** numeric string */,
      lastOnline: z.number(),
      balance: z.string() /** numeric string */,
    })
  ),
  nextPageStart: z.number().nullable(),
});

export type GetTokenHoldersResponseV1 = z.infer<
  typeof GetTokenHoldersResponseSchemaV1
>;

export interface FetchAllTokenHoldersOptions {
  shouldIncludeSelf?: boolean;
}

/**
 * Fetch all keyholders of `userAddress`
 * @param userAddress
 */
export async function fetchAllTokenHolders(
  userAddress: string | null,
  opts?: FetchAllTokenHoldersOptions
): Promise<HoldersResponseData | null> {
  if (!userAddress) return null;

  try {
    const res = await fetch(
      `/api/holders?subject=${userAddress}&filterSubject=${
        opts?.shouldIncludeSelf ? "false" : "true"
      }`
    );

    if (!res.ok) {
      const data = await res.json();
      throw new Error(data.error);
    }

    const data: HoldersResponseData = await res.json();

    return data;
  } catch (e) {
    console.error(e);
    return null;
  }
}
